/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useState} from 'react';
import Console from "../Console.jsx";
import Tabs from "../Tabs/Tabs.jsx";
import Tab from "../Tabs/Tab.jsx";
import useInterval from "../../hooks/useInterval.jsx";
import {BuildServers} from "../../Objects/BuildServers.jsx";

const BuildServerLogs = ({buildServerId}) => {
    const [logs, setLogs] = useState({
        buildKitLogs: [],
        builderLogs: [],
        proxyLogs: []
    })
    const [error, setError] = useState(null)
    const [currentTab, setCurrentTab] = useState(0)

    async function fetchLogs() {
        let result = await BuildServers(buildServerId).getLogs()

        if (result?.success === false) {
            setError("Failed to fetch logs. Displaying cached logs.")
            return
        }

        setLogs({
            buildKitLogs: result?.buildKitLogs ?? [],
            builderLogs: result?.builderLogs ?? [],
            proxyLogs: result?.proxyLogs ?? []
        })
        setError(null)
    }

    useEffect(() => {
        fetchLogs()
    }, [buildServerId]);

    useInterval(() => {
        fetchLogs()
    }, 10000)

    return (
        <Tabs activeKey={currentTab} onSelect={setCurrentTab} variant={'default'} isBox>
            <Tab eventKey={0} title={"Builder"}>
                <Console logs={logs.builderLogs} titel={"Builder logs"} error={error}/>
            </Tab>
            <Tab eventKey={1} title={"BuildKit"}>
                <Console logs={logs.buildKitLogs} titel={"BuildKit logs"} error={error}/>
            </Tab>
            <Tab eventKey={2} title={"Proxy"}>
                <Console logs={logs.proxyLogs} titel={"Proxy logs"} error={error}/>
            </Tab>
        </Tabs>
    );
}

export default BuildServerLogs;